import React from 'react';
import './ReferralCTA.css';

function ReferralCTA({
  title,
  subtitle,
  buttonLabel = 'Refer a friend',
  onButtonClick,
  showImage = true,
  imageSrc,
  imageAlt = 'Premsi.com referral bonus',
}) {
  const resolvedImageSrc = imageSrc ?? require('../../images/referral.webp');

  return (
    <section className="ReferralCTA" aria-label="Referral">
      <div className="ReferralCTA__card">
        <div className="ReferralCTA__copy">
          <h2 className="ReferralCTA__title">{title}</h2>
          <p className="ReferralCTA__subtitle">{subtitle}</p>
          <button type="button" className="ReferralCTA__button" onClick={onButtonClick}>
            {buttonLabel}
          </button>
        </div>

        {showImage && (
          <div className="ReferralCTA__illus" aria-hidden="true">
            <img loading="lazy" className="ReferralCTA__image" src={resolvedImageSrc} alt={imageAlt} />
          </div>
        )}
      </div>
    </section>
  );
}

export default ReferralCTA;

